<template>
  <!--
  <div id="nav">
    <router-link to="/">Home</router-link>
  </div>-->
  <router-view />
</template>

<script>
import snowf from "snowf";
export default {
  computed: {
    search() {
      return this.$store.state.searchedString;
    }
  },
  watch: {
    '$store.state.searchedString': function () {
    },
  },
  mounted() {
    //Snowfall for Christmas
    //https://github.com/Fuxy526/snowf
    const date = new Date();
    if (
      new Date(date.setHours(0, 0, 0)).toString() ===
      new Date(
        new Date(`${date.getFullYear()}-12-25`).setHours(0, 0, 0)
      ).toString()
    )
      snowf.init({
        size: 10,
        amount: 25,
        swing: 2,
        zIndex: 9999,
        color: "white",
        opacity: 0.7,
      });

    //Get stored dark/light mode selected data from either the logged in account or localStorage
    if (this.$store.state.isLoggedIn) {
      if (this.$store.state.screenMode === "dark") {
        let app = document.getElementById("app");
        app.style.background = "#131313";
        document.body.style.background = "#131313";
        this.$store.commit("setScreenMode", "dark");
      } else {
        app.style.background = "white";
        document.body.style.background = "white";
        this.$store.commit("setScreenMode", "white");
      }
    } else if (localStorage.getItem("ScreenMode") === "dark") {
      let app = document.getElementById("app");
      app.style.background = "#131313";
      document.body.style.background = "#131313";
      this.$store.commit("setScreenMode", "dark");
    } else {
      app.style.background = "white";
      document.body.style.background = "white";
      this.$store.commit("setScreenMode", "white");
    }
  },
};
</script>

<style>
* {
  transition: background-color 0.4s, all 200ms, color 50ms !important;
  /*Opacity transition for dark/lightmode */
  -ms-overflow-style: none;
  /* IE and Edge */
  scrollbar-width: none;
  /* Firefox */
  font-family: Montserrat, sans-serif;
  -ms-overflow-style: none;
  /* IE and Edge */
  scrollbar-width: none;
  /* Firefox */
}

/* body {
  background: var(--yungo-darkmode-background) !important;
} */

body {
  margin: 0;
  padding: 0;
}

h1 {
  color: #070014;
  font-size: 22px !important;
  margin-left: 25px !important;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 30px;
}

*::-webkit-scrollbar {
  display: none;
}

::-moz-selection {
  /* Code for Firefox */
  color: red;
  background: yellow;
}

::selection {
  color: white;
  background: var(--yungo-main-color);
}
</style>
